import CashIcon from '@ordr-as/icons/CashIcon';
import CreditCardIcon from '@ordr-as/icons/CreditCardIcon';
import InvoiceIcon from '@ordr-as/icons/InvoiceIcon';
import type {
  GuestInvoiceData,
  ListActivePaymentDto,
  PaymentMethodDto,
  UnintegratedPaymentFields,
} from '../../generated-api';
import { sortUnintegratedPaymentMethods } from './sort';

export const toPaymentTuple =
  (activePayments?: ListActivePaymentDto[]) =>
  (method: PaymentMethodDto): [PaymentMethodDto, ListActivePaymentDto | undefined] =>
    [method, activePayments?.find((ap) => ap.paymentMethod.id === method.id)];

const providerOrder = ['ADYEN', 'SOFTPAY', 'UNINTEGRATED'];

export const comparePaymentMethod = (methodA: PaymentMethodDto, methodB: PaymentMethodDto) => {
  if (methodA.paymentMethod === 'INTEGRATED_TERMINAL' && methodB.paymentMethod === 'INTEGRATED_TERMINAL') {
    return (methodA.label || methodA.id).localeCompare(methodB.label || methodB.id);
  }
  if (methodA.provider === 'UNINTEGRATED' && methodB.provider === 'UNINTEGRATED') {
    return sortUnintegratedPaymentMethods(methodA, methodB);
  }
  return providerOrder.indexOf(methodA.provider) - providerOrder.indexOf(methodB.provider);
};

export const getInitalStateForDynamicUnintegratedPaymentFields = (
  paymentMethodDto: PaymentMethodDto,
  invoiceData?: GuestInvoiceData
) => {
  const inital = paymentMethodDto.unintegratedPaymentFields?.reduce(
    (acc, cur) => ({ ...acc, [cur.name]: '' }),
    {}
  ) as Record<string, string>;

  if (paymentMethodDto?.provider === 'UNINTEGRATED' && paymentMethodDto.paymentMethod === 'INVOICE' && invoiceData) {
    return {
      ...inital,
      comment: invoiceData?.comment ?? '',
      externalReference: invoiceData?.customerRegistryId ?? invoiceData?.customerName ?? '',
      referencePerson: invoiceData?.referencePerson ?? '',
    };
  }

  return inital;
};

export const getPaymentIcon = (paymentMethod: PaymentMethodDto) => {
  switch (paymentMethod.paymentMethod) {
    case 'MOBILE_CARD_TERMINAL': {
      return <CreditCardIcon />;
    }
    case 'INTEGRATED_TERMINAL': {
      return <CreditCardIcon />;
    }
    case 'CASH': {
      return <CashIcon />;
    }
    case 'INVOICE': {
      return <InvoiceIcon />;
    }
    default: {
      break;
    }
  }
};
export const getFields = (paymentMethod: PaymentMethodDto): UnintegratedPaymentFields[] | undefined =>
  paymentMethod.unintegratedPaymentFields;
